import { render, staticRenderFns } from "./ApproverSettingsListPage.vue?vue&type=template&id=3cbeb998"
import script from "./ApproverSettingsListPage.vue?vue&type=script&lang=ts"
export * from "./ApproverSettingsListPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\808325\\Documents\\SsmlockEntryReqWebApp-IVC202512\\SsmlockEntryReqWebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cbeb998')) {
      api.createRecord('3cbeb998', component.options)
    } else {
      api.reload('3cbeb998', component.options)
    }
    module.hot.accept("./ApproverSettingsListPage.vue?vue&type=template&id=3cbeb998", function () {
      api.rerender('3cbeb998', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/approver-settings/ApproverSettingsListPage.vue"
export default component.exports